import { ErrorHandler, inject, Injectable } from "@angular/core";
import { LoggerService } from "@core/logging/logger.service";

/**
 * Catches every unhandled exception inside the Angular zone. fatal() forwards
 * to the error reporter through the LoggerService remote seam — do NOT also
 * call the reporter here (single-funnel rule, docs/logging/02-error-tracking.md).
 */
@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  private readonly log =
    inject(LoggerService).createContext("GlobalErrorHandler");

  handleError(error: unknown): void {
    // zone.js wraps unhandled promise rejections; unwrap so the reporter
    // receives the original error with its stack.
    const rejection = (error as { rejection?: unknown })?.rejection;
    this.log.fatal("Unhandled exception", rejection ?? error);
  }
}
